import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useParams } from 'react-router-dom';
import { http } from '../../../../config';
import { Loader } from '../../../core';
import AddObservation from '../add-observation/add-observation';

const EditEpe = ({ params = {} }) => {
	const { driveLogId, epeId } = useParams();
	const { redirectUrl = '' } = params;

	const { data: epe, isLoading } = useQuery({
		queryKey: ['releveEpe', epeId],
		queryFn: async () => {
			const { data } = await http.get(`/drive-log/${driveLogId}/epe/${epeId}`);
			return {
				id: data.id,
				observation_type: 'releve_epe',
				content: {
					cabin: data.train_number,
					trainStorageChoice: { name: data.station_start },
					dateTime: data.hour,
					cassetteNoted: data.cassette_noted,
					cassetteInstalled: data.cassette_installed,
					sens: data.sens,
					period: data.period,
					comment: data.comment,
					materialType: data.material_type,
				},
			};
		},
		enabled: !!driveLogId && !!epeId,
	});

	return (
		<Loader isLoading={isLoading || !epe}>
			<AddObservation
				observationData={epe}
				params={{ redirectUrl }}
			/>
		</Loader>
	);
};

export default EditEpe;
